import { Vehicle } from '../../../../../common/types/Vehiculo'

/** Distingeix variants amb el mateix id_vehiculo (p. ex. diverses entrades de cache_matriculas). */
export function vehiclesMatch(a: Vehicle, b: Vehicle): boolean {
  return (
    a.id_vehiculo === b.id_vehiculo &&
    a.id_vehiculo_ami === b.id_vehiculo_ami &&
    a.id_vivid === b.id_vivid &&
    a.cod_motor === b.cod_motor &&
    a.potencia_cv === b.potencia_cv
  )
}

export function vehicleListKey(vehicle: Vehicle, index: number): string {
  return [
    vehicle.id_vehiculo,
    vehicle.id_vehiculo_ami,
    vehicle.id_vivid,
    vehicle.cod_motor,
    vehicle.potencia_cv,
    index,
  ].join('-')
}
